import { TraceableProcess, TrackingEvent } from '../../services/analytics/model';

export class ReferralCodeUsed implements TrackingEvent {
  public readonly category = TraceableProcess.LANDLORD_LANDING;
  public readonly action = 'Referral Code Used';

  constructor(public readonly userId: number, public readonly referralType: string) {}
}
